/* unplugin-vue-components disabled */import { render } from "./share-dropdown.vue?vue&type=template&id=a2ebb778&scoped=true"
import script from "./share-dropdown.vue?vue&type=script&lang=js"
export * from "./share-dropdown.vue?vue&type=script&lang=js"

import "./share-dropdown.vue?vue&type=style&index=0&id=a2ebb778&lang=stylus"
import "./share-dropdown.vue?vue&type=style&index=1&id=a2ebb778&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ebb778"],['__file',"src/pages/chats/chat-sharing-v2/share-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2ebb778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2ebb778', __exports__)) {
    api.reload('a2ebb778', __exports__)
  }
  
  module.hot.accept("./share-dropdown.vue?vue&type=template&id=a2ebb778&scoped=true", () => {
    api.rerender('a2ebb778', render)
  })

}


export default __exports__